import type { FC } from "react";
import React from "react";

import clsx from "clsx";

import styles from "./simpleButton.module.scss";

import type { BaseButtonProps } from "../index";
import { ButtonSizes } from "../index";

interface SimpleButtonProps extends Omit<BaseButtonProps, "type"> {
	type: "submit" | "button";
}

const SimpleButton: FC<SimpleButtonProps> = ({
	children,
	className = "",
	loading,
	disabled,
	startIcon,
	endIcon,
	size,
	...rest
}) => {
	return (
		<button
			className={clsx(
				className,
				styles.btn,
				size === ButtonSizes.XS && styles.sizeXS,
				size === ButtonSizes.SM && styles.sizeSM
			)}
			disabled={loading || disabled}
			{...rest}
		>
			{!!startIcon && <div className="shrink-0">{startIcon}</div>}
			{typeof children === "string" ? (
				<p
					className={clsx(
						"font-semibold tracking-tight text-brown-400",
						(size === ButtonSizes.XS || size === ButtonSizes.SM) && "text-xs leading-4",
						size === ButtonSizes.MD && "text-base leading-5"
					)}
				>
					{children}
				</p>
			) : (
				children
			)}
			{!!endIcon && <div className="shrink-0">{endIcon}</div>}
		</button>
	);
};

export default SimpleButton;
